module.exports = __webpack_public_path__ + "media/images/global/icons/glass-bde916d22db251f160dcea5cd04d61f5.svg";